import { localDB } from './pouchdb-config';

/**
 * Initialize sample data in PouchDB
 */

// Mapping between country codes and currency codes
export const countryCurrencyMap = {
  US: 'USD',
  IN: 'INR',
  GB: 'GBP',
  EU: 'EUR',
  JP: 'JPY'
};

// Mapping between currency codes and country codes
export const currencyCountryMap = {
  USD: 'US',
  INR: 'IN',
  GBP: 'GB',
  EUR: 'EU',
  JPY: 'JP'
};

// Sample products with fixed IDs for easier reference
const sampleProducts = [
  {
    _id: 'product_1',
    type: 'product',
    name: 'Organic Apples',
    description: 'Fresh organic apples',
    is_organic: 1,
    image_url: 'https://images.unsplash.com/photo-1567306226416-28f0efdc88ce?w=200',
    active: true,
    pricing: {
      USD: 3.99,
      INR: 330,
      GBP: 3.15,
      EUR: 3.67,
      JPY: 605
    },
    countryStock: {
      US: 50,
      IN: 35,
      GB: 25,
      EU: 40,
      JP: 20
    },
    availability: ['US', 'IN', 'GB', 'EU', 'JP'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    _id: 'product_2',
    type: 'product',
    name: 'Bananas',
    description: 'Fresh bananas',
    is_organic: 0,
    image_url: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=200',
    active: true,
    pricing: {
      USD: 1.99,
      INR: 165,
      GBP: 1.55,
      EUR: 1.85,
      JPY: 300
    },
    countryStock: {
      US: 75,
      IN: 60,
      GB: 40,
      EU: 55,
      JP: 30
    },
    availability: ['US', 'IN', 'GB', 'EU', 'JP'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    _id: 'product_3',
    type: 'product',
    name: 'Organic Oranges',
    description: 'Fresh organic oranges',
    is_organic: 1,
    image_url: 'https://images.unsplash.com/photo-1547514701-42782101795e?w=200',
    active: false, // This product is inactive
    pricing: {
      USD: 4.99,
      INR: 415,
      GBP: 3.95,
      EUR: 4.60,
      JPY: 755
    },
    countryStock: {
      US: 30,
      IN: 25,
      GB: 20,
      EU: 35,
      JP: 15
    },
    availability: ['US', 'IN', 'GB', 'EU', 'JP'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

// Sample customers
const sampleCustomers = [
  {
    _id: 'VijayKumar',
    type: 'customer',
    email: 'sendvijay21@gmail.com',
    password: 'password@123',
    fname: 'Vijay',
    lname: 'Kumar',
    isAdmin: '0',
    mobile: '9491657949',
    createdAt: new Date().toISOString()
  },
  {
    _id: 'arjunchinn',
    type: 'customer',
    email: 'arjun.chinn@gmail.com',
    password: 'password@123',
    fname: 'Vijay',
    lname: 'Kumar',
    isAdmin: '0',
    mobile: '9491657949',
    createdAt: new Date().toISOString()
  },
  {
    _id: 'customer_2',
    type: 'customer',
    email: 'organicgreenshub.hyderabad@gmail.com',
    password: 'Password@123',
    fname: 'OGH',
    lname: 'Hyderabad',
    isAdmin: '1',
    createdAt: new Date().toISOString()
  }
];

// Sample orders
const sampleOrders = [
  {
    _id: 'order_1',
    type: 'order',
    customerId: 'customer_1',
    items: [
      {
        productId: 'product_1',
        name: 'Organic Apples',
        price: 3.99,
        quantity: 2
      },
      {
        productId: 'product_2',
        name: 'Bananas',
        price: 1.99,
        quantity: 3
      }
    ],
    totalAmount: 13.95,
    status: 'completed',
    shippingAddress: '123 Main St, Anytown, USA',
    date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days ago
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
  },
  {
    _id: 'order_2',
    type: 'order',
    customerId: 'customer_1',
    items: [
      {
        productId: 'product_2',
        name: 'Bananas',
        price: 1.99,
        quantity: 5
      }
    ],
    totalAmount: 9.95,
    status: 'completed',
    shippingAddress: '123 Main St, Anytown, USA',
    date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()
  }
];

// Initialize database with sample data via API
export const initializeDatabase = async () => {
  try {
    console.log('🔄 Initializing database via API...');
    
    const allDocs = [...sampleProducts, ...sampleCustomers, ...sampleOrders];
    const result = await localDB.bulkDocs(allDocs);
    
    console.log('✅ Database initialization complete:', result);
    return result;
  } catch (error) {
    console.error('❌ Error initializing database:', error);
    throw error;
  }
};

// Clear all data from database via API
export const clearDatabase = async () => {
  try {
    console.log('🗑️ Clear database not implemented via API');
    console.log('ℹ️ Use backend admin tools to clear database');
  } catch (error) {
    console.error('❌ Error clearing database:', error);
  }
};

// Sync handled by backend API
export const syncToRemoteDB = async () => {
  try {
    console.log('🔄 Sync handled automatically by backend API');
    return { success: true, message: 'Sync handled by backend' };
  } catch (error) {
    console.error('❌ Sync failed:', error);
    throw error;
  }
};

// Sync handled by backend API
export const syncFromRemoteDB = async () => {
  try {
    console.log('🔄 Sync handled automatically by backend API');
    return { success: true, message: 'Sync handled by backend' };
  } catch (error) {
    console.error('❌ Sync failed:', error);
    throw error;
  }
};

// Sync handled by backend API
export const syncBidirectional = async () => {
  try {
    console.log('🔄 Sync handled automatically by backend API');
    return { success: true, message: 'Sync handled by backend' };
  } catch (error) {
    console.error('❌ Sync failed:', error);
    throw error;
  }
};